import { db } from '../data/formData'

const formCollection = 'form'

export default new (class formService {
	addForm(form) {
		return db.collection(formCollection).add(form)
	}
})()
